import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthResponse, RegisterRequest, UpdateUserProfilePayload, UserProfile } from 'app/shared/models/user.model';
import { CurrentUserService } from './current-user.service';

@Injectable()
export class AuthService {
  apiUrl = environment.apiUrl;
  httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(
    public router: Router,
    private http: HttpClient,
    private currentUserService: CurrentUserService
  ) { }

  signinUser(query: any): Observable<any> {
    return this.http.post(this.apiUrl + '/auth/login', query, this.httpOptions);
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.currentUserService.clear();
    this.router.navigate(['/pages/login']);
  }

  isAuthenticated() {
    return !!localStorage.getItem('currentUser');
  }

  verifyOtp(query: any): Observable<any> {
    return this.http.post(this.apiUrl + '/auth/verify-otp', query, this.httpOptions);
  }

  sendOtpAgain(email: string): Observable<any> {
    return this.http.post(this.apiUrl + '/auth/resend-otp', { email }, this.httpOptions);
  }

  getCurrentUserProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${this.apiUrl}/auth/me`, this.httpOptions);
  }

  updateCurrentUserProfile(userId: number, payload: Partial<UpdateUserProfilePayload>): Observable<UserProfile> {
    return this.http.put<UserProfile>(`${this.apiUrl}/users/${userId}`, payload, this.httpOptions);
  }

  changePassword(payload: { currentPassword: string; newPassword: string }): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/auth/change-password`, payload, this.httpOptions);
  }

  resetPassword(token: string, newPassword: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.apiUrl}/auth/reset-password`, { token, newPassword }, this.httpOptions);
  }

  requestPasswordReset(email: string): Observable<{ message: string }> {
    const params = new HttpParams().set('email', email);
    return this.http.post<{ message: string }>(`${this.apiUrl}/auth/request-password-reset`, null, { params });
  }

  register(payload: RegisterRequest): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(this.apiUrl + '/auth/register', payload, this.httpOptions);
  }

  verifyEmail(token: string): Observable<void> {
    const params = new HttpParams().set('token', token);
    return this.http.post<void>(`${this.apiUrl}/auth/verify-email`, null, { params });
  }

  resendVerificationEmail(email: string): Observable<{ message: string }> {
    const params = new HttpParams().set('email', email);
    return this.http.post<{ message: string }>(`${this.apiUrl}/auth/resend-verification-email`, null, { params });
  }
}
